module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAABEQFVEQFRFQldEQFRFQVVEQFRFQVVEQFRHQ1dEQFVFQVRFQVVEQFRFQFRFQVVHQlZEQFQW+PL4AAAAEXRSTlMA6+NEs3m5i38+8IL516dsOGszKhUAAADFSURBVFjD7ZbLDoMgEADZRZGHL/7/Z0ts91BStyAXNDsXD4xjTMiCEgRBEG6LNh6M5h03eL863hnjwcg529vZOEfHD8z3ds4hBpKGAmdlQkASnDvIOUQkZs4h1A8mxHAlNCLar05MhEwqCNmYsPl/Y31oOd7LF+f6ED2zxb5D50io31B/++gxIYgJuDhGlnywTU2DjUoAk6oPqYAQeKli+N8jBORggQNtRzbvEI6kveCioVuvNbxDaANg9F/HJ0cQBEEo4wXXFkFn3uTxYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/hotel_power_equipment.png
// module id = Z9M0
// module chunks = 0